import axios from 'axios';
import { get_headers, GET_LEAD_FORM_WITH_ANSWERS, LEAD_SUBMIT_FORM } from '@/utils/constants/constants';
import alert_mixin from "@/utils/mixins/alert_mixin";
import NavigationBackButton from '@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue';

export default {
  name: 'LeadQuestionnaireForm',
  mixins: [alert_mixin],
  components: {NavigationBackButton},
  data: () => ({
    headers: get_headers(),
    safe_form_config: [],
    safe_forms: [],
    current_form_index: 0,
    section_open: [],
    requestInfoNote: '',
  }),
  mounted() {
    const leadFormId = sessionStorage.getItem('lead_form_id');
    axios
      .get(GET_LEAD_FORM_WITH_ANSWERS, {
        headers: this.headers,
        params: { lead_form_id: parseInt(leadFormId, 10) }
      })
      .then(({ data }) => {
        const formPayload = data.data;
        this.safe_form_config = [formPayload];

        this.safe_forms = this.safe_form_config.map(f => {
          let ans = {};
          f.sections.forEach(sec =>
            sec.questions.forEach(q => {
              ans[q.section_question_id] = q.multi_select_choices.length
                ? Array.isArray(q.answer) ? q.answer : []
                : q.answer || '';
            })
          );
          return ans;
        });

        this.section_open = this.safe_form_config.map(f =>
          f.sections.map(() => true)
        );
      });
  },
  methods: {
    back_to_application_overview() {
      this.$router.back();
    },

    _validateIndices(form_idx, sec_idx) {
      const form_index = Math.trunc(Number(form_idx));
      const section_index = Math.trunc(Number(sec_idx));

      if (!Number.isSafeInteger(form_index) || !Number.isSafeInteger(section_index) || 
          form_index < 0 || section_index < 0) return { valid: false };
      
      if (!Array.isArray(this.section_open)) return { valid: false };
      if (form_index >= this.section_open.length) return { valid: false };
      
      const form_section = this.section_open.at(form_index);
      if (!Array.isArray(form_section)) return { valid: false };

      const section_value = form_section.at(section_index);
      if (section_value === undefined) return { valid: false };

      return {
        valid: true,
        form_section: [...form_section],
        section_value: Boolean(section_value),
        form_index,
        section_index
      };
    },

    isSectionOpen(form_idx, sec_idx) {
      const validation = this._validateIndices(form_idx, sec_idx);
      return validation.valid && validation.section_value;
    },

    toggleSection(form_idx, sec_idx) {
      const validation = this._validateIndices(form_idx, sec_idx);
      if (!validation.valid) return;
      
      this.$set(
        validation.form_section,
        validation.section_index,
        !validation.section_value
      );
    },

    nextForm() {
      if (this.current_form_index < this.safe_form_config.length - 1) {
        this.current_form_index++;
      }
    },
    
    prevForm() {
      if (this.current_form_index > 0) {
        this.current_form_index--;
      }
    },
    
    async submitAnswers() {
      if (this.safe_form_config.length === 0 || this.safe_forms.length === 0) {
        this.show_error('Form data not available.');
        return;
      }

      const lead_form_id = sessionStorage.getItem('lead_form_id') || this.lead_form_id;
      const form = this.safe_form_config[0];
      const safeForm = this.safe_forms[0];
      const answers = [];

      form.sections.forEach(section => {
        section.questions.forEach(q => {
          answers.push({
            question_id: q.section_question_id,
            answer: safeForm[q.section_question_id]
          });
        });
      });

      try {
        const response = await axios.post(LEAD_SUBMIT_FORM, {
          lead_form_id,
          answers
        }, { headers: this.headers });

        if (response.data.status === 'success') {
          this.show_success('Form submitted successfully.');
        } else {
          this.show_error(response.data.message || 'Something went wrong.');
        }
      } catch (error) {
        this.show_error(
          error.response?.data?.message ||
          error.message ||
          'An unexpected error occurred.'
        );
      }
    }
  }
};